import axios from "axios"
import appConfig from "@/helpers/appConfig.js"
import realtimeEvents from "@/events/index"
import { storeModules } from "./modules/index"
import { createStore } from "vuex"

//Set Base API URL
const axiosConfig = appConfig.axios()
axios.defaults.baseURL = appConfig.api + "v5"
axios.defaults.withCredentials = axiosConfig.withCredentials
axios.defaults.withXSRFToken = axiosConfig.withXSRFToken

const debug = process.env.NODE_ENV !== "production"

const store = createStore({
  modules: storeModules,
  strict: debug,
  plugins: [realtimeEvents]
})

export default store
